import { useEffect, useState } from "react";
import { getApiBase, getJSON } from "../lib/api";

function inferCategory(g) {
  const c = String(g.category || g.Category || "").trim();
  if (c) return c;
  const slug = String(g.slug || g.Slug || "").toLowerCase();
  if (slug.startsWith("property-type")) return "Property Types";
  if (slug.startsWith("location-")) return "Locations";
  return "Guides";
}

// src/hooks/useGuidesList.js
// ...
const num = (v) => Number(String(v ?? 0).replace(/,/g, "")) || 0;


function normalise(g) {
  const dateRaw = String(g.date || g.Date || "").trim();
  const date = /^\d{4}-\d{2}-\d{2}$/.test(dateRaw) ? `${dateRaw}T00:00:00Z` : (dateRaw || "");

  const image = (() => {
    const v = String(g.image || g.Image || g.imageUrl || "").trim();
    if (!v) return "";
    if (/^https?:\/\//i.test(v)) return v;
    return v.startsWith("/content/") ? v : `/content/images/${v.replace(/^\/+/, "")}`;
  })();

  return {
    ...g,
    id: String(g.id ?? g.ID ?? g.Id ?? ""),
    title: String(g.title || g.Title || ""),
    excerpt: String(g.excerpt || g.Excerpt || ""),
    slug: String(g.slug || g.Slug || ""),
    file: String(g.file || g.File || g.filename || g.body_url || ""),
    category: inferCategory(g),
    date,
    image,
     base_downloads: num(g.base_downloads),
  downloads_start: g.downloads_start || g.date || null,
  date: g.date || null,
  };
}

export default function useGuidesList() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const base = await getApiBase();
        console.log("[guides] using base:", base);

        const json = await getJSON("/api/guides/list");
        const raw = Array.isArray(json)
          ? json
          : (Array.isArray(json.guides) ? json.guides : (json.items || []));

        const all = raw.map(normalise).filter(x => x.title);
        if (!cancelled) setItems(all);
        console.log("[guides] loaded:", all.length);
      } catch (e) {
        console.warn("[guides] fetch failed", e);
        if (!cancelled) setError(String(e.message || e));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return items;
}
